@for (ticket of tickets(); track ticket) {
  <div class="ticket">
    <div class="ticket-row ticket-row-half">
      <span class="ticket-label">{{ helperService.ColumnLabels.SRM_TICKET_DATE }}</span>
      <span class="ticket-value">{{ ticket.createdAt | luxonDate }} – {{ ticket.createdAt | luxonDate: "T" }} Uhr</span>
    </div>
    <div class="ticket-row ticket-row-half">
      <span class="ticket-label">{{ helperService.ColumnLabels.SRM_TICKET_STATUS }}</span>
      <span class="ticket-value"><ui-srm-ticket-status [status]="ticket.status"></ui-srm-ticket-status></span>
    </div>
    <div class="ticket-row ticket-row-full">
      <span class="ticket-label">{{ helperService.ColumnLabels.SRM_TICKET_SUBJECT }}</span>
      <span class="ticket-value"><a [link]="ticket" uiSrmTicketLink>{{ ticket.title }}</a></span>
    </div>
    <div class="ticket-row ticket-row-full">
      <span class="ticket-label">{{ helperService.ColumnLabels.SRM_TICKET_NUMBER }}</span>
      <span class="ticket-value">
        @if (ticket.crmIdentifier) {
          <a [link]="ticket" uiSrmTicketLink>{{ ticket.crmIdentifier }}</a>
        } @else {
          -
        }
      </span>
    </div>
    <div class="ticket-actions">
      <a [link]="ticket" mat-button uiSrmTicketLink matTooltip="Details anzeigen" matTooltipPosition="above">
        <ui-icon faName="eye" faStyle="light"></ui-icon>
        Details anzeigen
      </a>
    </div>
  </div>
}
